import { themeObject } from '../../../lib';

export const styles = {
    detailsDrawer: {
        maxWidth: '570px',
        height: '100%',
        '& .MuiPaper-root': {
            '& .drawer-content': {
                overflowY: 'auto',
                scrollbarColor: 'auto',
            },
        },
    },
    headerContainer: {
        display: 'flex',
        alignItems: 'center',
        maxWidth: '500px',
    },
    headerTextAndChipContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
    },
    headerTextStyles: {
        fontFamily: 'Raleway !important',
        fontWeight: '500 !important',
        fontSize: '24px !important',
        lineHeight: '28.18px !important',
        color: `${themeObject.palette.primary[700]} !important`,
        fontVariantNumeric: 'lining-nums',
    },
    chipContainer: {
        marginTop: '9px',
        marginLeft: '10px',
    },
    readOnlyContainer: {
        height: '100%',
        overflowY: 'auto',
        h1: {
            lineHeight: '100%',
        },
    },
    readOnlyCodeStyles: {
        width: '510px',
        backgroundColor: themeObject.palette.grayScale[50],
        border: `1px solid ${themeObject.palette.grayScale[100]}`,
        borderRadius: '0px 0px 4px 4px',
        padding: '8px',
        wordBreak: 'break-word',
    },
};
